import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "introduction"
};
const _hoisted_4 = {
  style: {
    "width": "20%",
    "font-size": "30px",
    "font-family": "siyuan_Bold",
    "font-weight": "bold",
    "color": "#3EBDD6"
  }
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "schedule"
};
const _hoisted_7 = {
  class: "schedule_t"
};
const _hoisted_8 = {
  class: "schedule_t_l",
  style: {
    "flex": "1"
  }
};
const _hoisted_9 = {
  class: "schedule_dom"
};
const _hoisted_10 = {
  class: "course"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  key: 1,
  class: "body_pe"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "introduction"
};
const _hoisted_15 = ["innerHTML"];
const _hoisted_16 = {
  class: "box1"
};
const _hoisted_17 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_18 = {
  class: "schedule"
};
const _hoisted_19 = {
  class: "schedule_t"
};
const _hoisted_20 = {
  class: "schedule_t_l"
};
const _hoisted_21 = {
  class: "schedule_dom"
};
const _hoisted_22 = {
  class: "course"
};
const _hoisted_23 = {
  class: "course_list"
};
const _hoisted_24 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return $setup.Client === 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "body",
    style: _normalizeStyle(['zoom:' + ($setup.Client ? '20%' : '') + ';', {
      "min-width": "1560px"
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: $setup.pic,
    class: "coverUrl"
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("h3", _hoisted_4, _toDisplayString($setup.get_data.benefitName), 1), _createElementVNode("span", {
    style: {
      "width": "48%",
      "font-size": "16px",
      "font-family": "siyuan_Bold",
      "font-weight": "400",
      "color": "#000000",
      "white-space": "pre-wrap"
    },
    innerHTML: $setup.get_data.benefitExplain
  }, null, 8, _hoisted_5), _createElementVNode("div", null, [_cache[1] || (_cache[1] = _createElementVNode("h3", {
    style: {
      "font-size": "24px",
      "font-family": "siyuan_Bold",
      "font-weight": "bold",
      "color": "#000000"
    }
  }, "加入训练大家庭", -1)), _cache[2] || (_cache[2] = _createElementVNode("span", {
    style: {
      "font-size": "16px",
      "font-family": "siyuan_Bold",
      "font-weight": "400",
      "color": "#000000"
    }
  }, "开启口腔功能训练，纠正不良习惯", -1)), _createVNode(_component_el_button, {
    style: {
      "width": "80%",
      "margin": "auto",
      "height": "52px",
      "font-size": "18px",
      "font-family": "siyuan_Bold",
      "font-weight": "400",
      "color": "#FFFFFF"
    },
    type: "primary",
    onClick: $setup.show,
    round: ""
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("立即报名吧", -1)])),
    _: 1,
    __: [0]
  }, 8, ["onClick"])])]), _cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "jgn_img",
    style: {
      "width": "100%",
      "margin-bottom": "100px"
    }
  }, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/gyhd_img.jpg",
    style: {
      "width": "100%"
    },
    alt: ""
  })], -1)), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[3] || (_cache[3] = _createElementVNode("div", null, [_createElementVNode("h3", {
    style: {
      "font-size": "24px",
      "font-weight": "400",
      "font-family": "siyuan_Bold",
      "color": "rgba(0, 0, 0, 1)"
    }
  }, "公益训练："), _createElementVNode("h1", {
    style: {
      "font-size": "24px",
      "font-weight": "400",
      "font-family": "siyuan_Bold",
      "color": "#13A4BF"
    }
  }, "口腔肌功能训练（您的训练进度）")], -1)), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: "schedule_dom_t",
    style: _normalizeStyle('width:' + $setup.get_data.status + '%;')
  }, null, 4), _createElementVNode("div", {
    class: "schedule_dom_m",
    style: _normalizeStyle('left:' + ($setup.get_data.status - 5) + '%;')
  }, [_createElementVNode("span", null, _toDisplayString($setup.get_data.status) + "%", 1)], 4)])]), _cache[4] || (_cache[4] = _createElementVNode("div", {
    style: {
      "height": "50%",
      "width": "1px",
      "background": "#EFEFEF"
    }
  }, null, -1)), _cache[5] || (_cache[5] = _createElementVNode("div", {
    style: {
      "justify-content": "center",
      "padding": "0px 10%",
      "box-sizing": "border-box",
      "flex": "1"
    }
  }, [_createElementVNode("span", {
    style: {
      "font-size": "16px",
      "font-family": "siyuan_Bold",
      "font-weight": "400",
      "color": "#000000"
    }
  }, " 米檬口腔肌功能训练公益项目，已连续服务8年+，我们为有需要且适合（口呼吸、嘴唇闭合不良、吐舌吞咽等情况) 的儿童和青少年，提供公益指导。 ")], -1))]), _cache[6] || (_cache[6] = _createElementVNode("div", {
    style: {
      "background": "#13A4BF"
    }
  }, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/welfare_details/hb.png",
    style: {
      "width": "100%"
    },
    alt: ""
  })], -1))]), _createElementVNode("div", _hoisted_10, [_cache[7] || (_cache[7] = _createElementVNode("h1", null, "课程目录", -1)), $setup.get_data.materials ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "course_list",
    style: _normalizeStyle('height:' + $setup.domheight)
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.get_data.materials, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onClick: $event => $setup.open(item.url, index),
      style: _normalizeStyle(item.hide || item.isCover == 1 ? 'display: none;' : '')
    }, [_createElementVNode("span", null, _toDisplayString(item.title), 1)], 12, _hoisted_11);
  }), 128))], 4)) : _createCommentVNode("", true)])])], 4)) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("img", {
    src: $setup.pic,
    class: "coverUrl"
  }, null, 8, _hoisted_13), _createElementVNode("div", _hoisted_14, [_cache[12] || (_cache[12] = _createElementVNode("h3", {
    style: {
      "font-size": "3rem",
      "color": "#41B9B2"
    }
  }, "口腔肌功能训练", -1)), _createElementVNode("span", {
    style: {
      "font-size": "2rem",
      "line-height": "5rem",
      "white-space": "pre-wrap"
    },
    innerHTML: $setup.get_data.benefitExplain
  }, null, 8, _hoisted_15), _cache[13] || (_cache[13] = _createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/new/image.png",
    style: {
      "width": "100%"
    },
    alt: ""
  }, null, -1)), _createElementVNode("div", _hoisted_16, [_cache[10] || (_cache[10] = _createElementVNode("h3", {
    style: {
      "font-size": "4rem"
    }
  }, "加入训练大家庭", -1)), _cache[11] || (_cache[11] = _createElementVNode("span", {
    style: {
      "font-size": "2.5rem",
      "line-height": "6rem"
    }
  }, "开启口腔功能训练，纠正不良习惯", -1)), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_button, {
    type: "primary",
    color: "#41B9B2",
    onClick: $setup.show,
    round: ""
  }, {
    default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("立即报名吧", -1)])),
    _: 1,
    __: [9]
  }, 8, ["onClick"])])])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_cache[14] || (_cache[14] = _createElementVNode("div", null, [_createElementVNode("span", {
    style: {
      "font-size": "4rem"
    }
  }, "公益训练："), _createElementVNode("h2", {
    style: {
      "font-size": "3rem",
      "color": "#41B9B2",
      "margin": "0"
    }
  }, "口腔肌功能训练(您的训练进度)")], -1)), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", {
    class: "schedule_dom_t",
    style: _normalizeStyle('width:' + $setup.get_data.status + '%;')
  }, null, 4), _createElementVNode("div", {
    class: "schedule_dom_m",
    style: _normalizeStyle('left:' + $setup.get_data.status + '%;')
  }, [_createElementVNode("span", null, _toDisplayString($setup.get_data.status) + "%", 1)], 4)])]), _cache[15] || (_cache[15] = _createElementVNode("div", {
    style: {
      "border-top": "3px dotted rgba(0,0,0,0.5)",
      "padding": "8% 0"
    }
  }, [_createElementVNode("span", {
    style: {
      "font-size": "2.3rem"
    }
  }, " 米檬口腔肌功能训练公益项目，已连续服务8年+，我们为有需要且适合（口呼吸、嘴唇闭合不良、吐舌吞咽等情况) 的儿童和青少年，提供公益指导。 ")], -1))]), _cache[16] || (_cache[16] = _createElementVNode("div", {
    style: {
      "background": "#41B9B2",
      "margin-bottom": "0"
    }
  }, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/welfare_details/hb_pe.png",
    style: {
      "width": "100%"
    },
    alt: ""
  })], -1))]), _createElementVNode("div", _hoisted_22, [_cache[17] || (_cache[17] = _createElementVNode("h3", {
    style: {
      "font-size": "3rem"
    }
  }, "课程目录", -1)), _createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.get_data.materials, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onClick: $event => $setup.open(item.url, index),
      class: "course_list_item",
      style: _normalizeStyle(item.hide || item.isCover == 1 ? 'display: none;' : '')
    }, [_createElementVNode("span", null, _toDisplayString(item.title), 1)], 12, _hoisted_24);
  }), 128))])])]));
}